(() => {
  const selector = '[data-ef-community-carousel]';

  const initialise = (section) => {
    if (section.dataset.initialised === 'true' || !window.Swiper) return;
    const slider = section.querySelector('.ef-community-carousel__slider');
    if (!slider || slider.querySelectorAll('.swiper-slide').length === 0) return;

    section.dataset.initialised = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = Number(section.dataset.autoplaySpeed) || 10000;
    const setMobileActive = (swiper) => {
      if (!window.matchMedia('(max-width: 767px)').matches) {
        swiper.slides.forEach((slide) => slide.classList.remove('is-mobile-active'));
        return;
      }

      swiper.slides.forEach((slide) => slide.classList.remove('is-mobile-active'));
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) activeSlide.classList.add('is-mobile-active');
    };

    const swiper = new window.Swiper(slider, {
      slidesPerView: 'auto',
      loop: slider.querySelectorAll('.swiper-slide').length > 1,
      speed,
      allowTouchMove: true,
      watchSlidesProgress: true,
      autoplay: reduceMotion
        ? false
        : {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
      on: {
        init() {
          setMobileActive(this);
        },
        slideChangeTransitionStart() {
          setMobileActive(this);
        },
        resize() {
          setMobileActive(this);
        }
      }
    });

    slider.addEventListener('mouseenter', () => {
      if (!reduceMotion) swiper.autoplay.stop();
    });

    slider.addEventListener('mouseleave', () => {
      if (!reduceMotion) swiper.autoplay.start();
    });

    slider.addEventListener('focusin', () => {
      if (!reduceMotion) swiper.autoplay.stop();
    });

    slider.addEventListener('focusout', () => {
      if (!reduceMotion && !slider.contains(document.activeElement)) swiper.autoplay.start();
    });
  };

  const start = () => {
    document.querySelectorAll(selector).forEach(initialise);
  };

  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(selector).forEach(initialise);
  });

  if (document.readyState !== 'loading') start();
})();

